export const CYPRESS_MEMBERSHIP_REACTIVATION_COMPLETE_EVENT =
  "gl:cypress-membership-reactivated";
